import { Directive, HostListener, ElementRef, Renderer2, AfterViewInit, DoCheck } from '@angular/core';
import * as $ from 'jquery';
import { CountryDataService } from './services/country.service';
import { EmitterService } from './services/emitter.service';
window['$'] = window['jQuery'] = $;

@Directive({
  selector: '.floatLabel'
})
export class FloatLabelDirective implements AfterViewInit, DoCheck {
  inputOnFocus = false;
  previousInputVal;
  constructor(
    private eleRef: ElementRef,
    private renderer: Renderer2,
    private CountryDataService :CountryDataService,
    private emitterService: EmitterService
  ) {}

  ngAfterViewInit() {
    this.floatLabelOnInputValue();
    this.previousInputVal = this.eleRef.nativeElement.value;
  }

  ngDoCheck() {
    let currentInputValue = this.eleRef.nativeElement.value;
    if ((this.previousInputVal !== currentInputValue) && !this.inputOnFocus) {
      this.previousInputVal = currentInputValue;
      this.floatLabelOnInputValue();
    }
  }

  @HostListener('focus', ['$event'])
  onfocus() {
    this.inputOnFocus = true;
    this.renderer.addClass(this.eleRef.nativeElement.nextElementSibling, "active");
    if(this.eleRef.nativeElement.nextElementSibling.classList.contains('phone') && this.CountryDataService.country == "SE"){
      this.emitterService.broadcastSwedenlableForPhoneNumer(true)
    }
    let self = this.eleRef.nativeElement;
    let ww = document.body.clientWidth;
    if (ww <= 767) {
      $(".arrow_box_small").show();
      $(".arrow_box").show();
    } else {
      // if ($(self).hasClass("pwdFloatLabel")){
      //   $(self).parents("form").find(".arrow_box_small, .arrow_box").hide();
      //   $(self).keypress(function(){
      //     $(self).parents("form").find(".passwrd_tooltip").show();
      //   });
      // } else {
      //   $(self).parents("form").find(".arrow_box_small, .arrow_box").hide();
      // }
    }
  }

  @HostListener('blur', ['$event'])
  onfocusOut() {
    this.inputOnFocus = false;
    this.floatLabelOnInputValue();
    $(this.eleRef.nativeElement).parents("form").find(".arrow_box_small, .arrow_box").show();
  }

  @HostListener('keypress', ['$event']) keyPress(e: KeyboardEvent) {
    if (this.eleRef.nativeElement &&  this.eleRef.nativeElement.classList && this.eleRef.nativeElement.classList.contains("inputWithoutDecimal")) {
      if (e.which > 31 && (e.which < 48 || e.which > 57)) {
        return false;
      }
    }

    if (this.eleRef.nativeElement.parentElement.id === "phoneNumberFlag") {
      if (this.eleRef.nativeElement.value.length >= (this.CountryDataService.country == "SE" ? 18 : 15)) {
        return false;
      }
    }
  }

  floatLabelOnInputValue() {
    if (this.eleRef.nativeElement.nextElementSibling) {
      if (this.eleRef.nativeElement.value.length > 0) {
        this.renderer.addClass(this.eleRef.nativeElement.nextElementSibling, "active");
        if(this.eleRef.nativeElement.nextElementSibling.classList.contains('phone') && this.CountryDataService.country == "SE"){
           this.emitterService.broadcastSwedenlableForPhoneNumer(true)
        }
      } else {
        this.renderer.removeClass(this.eleRef.nativeElement.nextElementSibling, "active");
        if(this.eleRef.nativeElement.nextElementSibling.classList.contains('phone') && this.CountryDataService.country == "SE"){
           this.emitterService.broadcastSwedenlableForPhoneNumer(false)
       }
      }
    }
  }
}
